import React from 'react';
import { useEffect,useState } from 'react';
import { Row, Col } from 'reactstrap';

import { LatestTransationData } from '../../CommonData/Data/index';

const LatestTransation = (props) => {
    const store = props.store;
    const [midnightTime, setMidnightTime] = useState(null);

    useEffect(() => {
      const getMidnightTime = () => {
        const now = new Date();
        
        // Create a new date at 00:01 AM of the current day
        const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 1, 0, 0);
        
        // Convert to milliseconds since epoch
        const midnightTimeInMs = midnight.getTime();
        
        setMidnightTime(midnightTimeInMs);
      };
    
      getMidnightTime();
    }, []);

    const[LatestTransationData, setLatesttransactiondata] = useState([]);

    useEffect(()=>{
        const fetchData=async()=>{
          const res = await fetch(`https://easyboxstoresapi.uuidesign.xyz/api/getOrderstoday?store=${store}&today=${midnightTime}`);
          const data = await res.json();
          setLatesttransactiondata(data)
        }
    
        if(store && midnightTime){
          fetchData();
        }
    
      },[store,midnightTime])

    return (
        <React.Fragment>
            <Row>
                <Col lg={12}>
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title mb-4">Today orders</h4>

                            <div className="table-responsive">
                                <table className="table table-centered table-nowrap mb-0">

                                    <thead>
                                        <tr>
                                            {/* <th scope="col" style={{ width: "50px" }}>
                                                <div className="form-check">
                                                    <label className="form-check-label" htmlFor="customCheckall"></label>
                                                </div>
                                            </th> */}
                                            <th scope="col" style={{ width: "60px" }}></th>
                                            <th scope="col">Order Number</th>
                                            <th scope="col">Created At</th>
                                            <th scope="col">Order value</th>
                                            <th scope="col">Customer</th>
                                            <th scope="col">Contact</th>
                                            <th scope="col">Location</th>
                                            <th scope="col">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {LatestTransationData.map((item, key) => (<tr key={key}>
                                            <td>
                                                <div className="form-check">
                                                    <input type="checkbox" className="form-check-input" id={item.id}
                                                    />
                                                    <label className="form-check-label" htmlFor={item.id}></label>
                                                </div>
                                            </td>
                                            {/* <td>
                                                {item.src ? <img src={item.src} alt="user" className="avatar-xs rounded-circle" /> : <div className="avatar-xs">
                                                    <span className="avatar-title rounded-circle bg-soft-primary text-success">
                                                        {item.clientName.charAt(0)}
                                                    </span>
                                                </div>}
                                            </td> */}
                                            <td>
                                                <h5 className="mb-1 font-size-12">{item.orderNumber}</h5>
                                               
                                            </td>
                                            <td> {item.createdAt}</td>
                                            <td>Kes. {item.orderValue}</td>
                                            <td>{item.customerName}</td>
                                            <td>{item.customerPhone}</td>

                                            <td>
                                                {item.deliveryLocation}
                                            </td>
                                            <td>
                                                {item.status == 'Delivered' &&
                                                <>
                                                    <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "success"}></i> {item.status}
                                                </>
                                                }
                                                {item.status == 'Pending' &&
                                                <>
                                                    <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {item.status}
                                                </>
                                                }
                                                {item.status == 'Transit' &&
                                                <>
                                                    <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "info"}></i> {item.status}
                                                </>
                                                }
                                                {item.status == 'Dispatch' &&
                                                <>
                                                    <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "warning"}></i> {item.status}
                                                </>
                                                }
                                                {item.status == 'Cancelled' &&
                                                <>
                                                    <i className={"mdi mdi-checkbox-blank-circle me-1 text-" + "danger"}></i> {item.status}
                                                </>
                                                }
                                                
                                            </td>
                                            {/* <td>
                                                <button type="button" className="btn btn-outline-success btn-sm me-1">Edit</button>
                                                <button type="button" className="btn btn-outline-danger btn-sm me-1">Cancel</button>
                                            </td> */}
                                        </tr>))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default LatestTransation;